import { useQuery } from '@tanstack/react-query';

import { SystemAddonsAvailability } from '@api/types.gen';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { buildUrl } from './build-url';
import { queryKeys } from './query-keys';

export const queryKey = [...queryKeys.base(), 'info'] as const;

export type ContainerPlatform =
  | 'Docker Standalone'
  | 'Docker Swarm'
  | 'Kubernetes'
  | 'Podman';

export interface SystemInfoResponse {
  platform: ContainerPlatform;
  agents: number;
  edgeAgents: number;
  // addonsAvailable reports whether the addon lifecycle can be used, and when
  // it can't, names which gate is failing (Kubernetes or FIPS mode) so the UI
  // can show a specific, static warning instead of requiring an admin to
  // attempt an operation first.
  addonsAvailable: SystemAddonsAvailability;
}

async function getSystemInfo() {
  try {
    const { data } = await axios.get<SystemInfoResponse>(buildUrl('info'));
    return data;
  } catch (error) {
    throw parseAxiosError(error as Error);
  }
}

export function useSystemInfo() {
  return useQuery(queryKey, getSystemInfo, {
    ...withError('Unable to retrieve system info'),
  });
}
